import React, { useEffect } from "react";
import { isIOS, isAndroid } from "react-device-detect";
import { Redirect } from "react-router-dom";

/**
 * /s — smart store link:
 * iOS → App Store, Android → Play Store, otherwise → landing page.
 */
const StoreRedirect = () => {
  useEffect(() => {
    if (isIOS && process.env.REACT_APP_APP_STORE_URL) {
      window.location.replace(process.env.REACT_APP_APP_STORE_URL);
      return;
    }
    if (isAndroid && process.env.REACT_APP_GOOGLE_PLAY_URL) {
      window.location.replace(process.env.REACT_APP_GOOGLE_PLAY_URL);
    }
  }, []);

  if (isIOS || isAndroid) {
    return null;
  }

  return <Redirect to="/" />;
};

export default StoreRedirect;
